import React from 'react';
import { compose } from 'react-recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { TemplatesPreview } from '@dev/ee-modules';
import { withRouter } from 'react-router-dom';
import { findIndex, map } from 'lodash-es';
import { Portal } from '@material-ui/core';

import { SetToastPortalWrapper } from '@/store/toast/actions';
import { ClearPreviewCampaign } from '@/store/campaigns/actions';
import { CampaignsInterface, CampaignTemplateInterface } from '@/store/campaigns/types';
import { ApplicationState, BrowserInterface } from '@/store';
import { PreviewProps, TemplatesDropdownOption, PreviewState } from './PreviewInterface';

interface StateToProps {
    campaigns: CampaignsInterface;
    browser?: BrowserInterface;
}

interface DispatchProps {
    ClearPreviewCampaign?: () => void;
    SetToastPortalWrapper: (isInsidePortal: boolean) => void;
}

type Props = PreviewProps & StateToProps & DispatchProps;

class Preview extends React.Component<Props, PreviewState> {
    public state = {
        currentTemplateIndex: 0,
    };

    public componentDidMount() {
        this.props.SetToastPortalWrapper(true);
    }

    public componentWillUnmount() {
        this.props.SetToastPortalWrapper(false);
    }

    private getDropdownItems(): TemplatesDropdownOption[] {
        const { templates } = this.props.campaigns.currentPreview;
        return templates
            ? map(
                  templates,
                  (template): TemplatesDropdownOption => ({
                      label: template.name,
                      value: template.html,
                  })
              )
            : [];
    }

    private handleTemplateListItemClick(
        ev: React.MouseEvent<HTMLElement>,
        pickedTemplate: TemplatesDropdownOption
    ): void {
        const { templates } = this.props.campaigns.currentPreview;
        const index = findIndex(
            templates,
            (template: CampaignTemplateInterface) => template.name === pickedTemplate.label
        );

        this.setState({ currentTemplateIndex: index });
    }

    public render(): JSX.Element {
        const { campaigns, browser, ClearPreviewCampaign } = this.props;
        const name = campaigns.currentPreview.campaign.Name;
        const { currentTemplateIndex } = this.state;
        const templateList = this.getDropdownItems();
        const currentHtml = templateList[currentTemplateIndex]?.value || 'Loading';
        const isMobile = browser.lessThan.hd;

        return (
            <Portal>
                <TemplatesPreview
                    open={true}
                    browser={browser}
                    isDrawerMenuFolded={false}
                    templateList={templateList?.length > 1 ? this.getDropdownItems() : null}
                    onItemClick={this.handleTemplateListItemClick.bind(this)}
                    templateHtml={currentHtml}
                    templateName={name}
                    isMobile={isMobile}
                    onCloseClick={() => {
                        ClearPreviewCampaign();
                    }}
                />
            </Portal>
        );
    }
}

const dispatchedActions = { ClearPreviewCampaign, SetToastPortalWrapper };

const mapStateToProps = (state: ApplicationState): StateToProps => ({
    campaigns: state.campaigns,
    browser: state.browser,
});

export default compose(
    withTranslation(),
    withRouter,
    connect<StateToProps, DispatchProps, PreviewProps>(mapStateToProps, dispatchedActions)
)(Preview);
